module.exports = __webpack_public_path__ + "img/spinner.bcce0475.svg";